import * as Yup from 'yup';

export const reactivateFormValidationSchema = Yup.object().shape({
  expirationDate: Yup.date().min(new Date()).required()
});
